import template from './routes.create.html';
import controller from './routes.create.controller';
import './routes.create.controller';

let routescreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default routescreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/routes/create/routes.create.component.js